import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import Form from '../form/Form';
import FieldGroup from '../field_group/FieldGroup';
import { listACBrand } from '../../redux/references/ac_actions';
import { requiredValidator } from '../field_group/validators';
import { fromCoolingCap, getErrorValue } from '../../utils/utility';

export class ACSplitTypeDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  renderOption(item, prefix) {
    return (
      <option key={prefix ? `${prefix}${item.id}` : item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  getACData() {
    return this.formRef.getFormData(['cooling_capacity']);
  }

  componentDidMount() {
    this.props.listBrand();
  }

  render() {
    const {
      name,
      brand_id,
      type,
      SEER,
      cooling_capacity,
      unit,
      power_required,
      description,
      image,
    } = this.props.ac;

    const { t, disabled, fieldErrors, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => (this.formRef = ref)}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="air-conditioning-split-type-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder="Name"
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-split-type-type"
          field="type"
          componentClass="select"
          label={t('type')}
          placeholder={t('type')}
          value={type}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.types.map(type => this.renderOption(type, 'act'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-split-type-brand"
          field="brand_id"
          componentClass="select"
          label={t('brand')}
          placeholder={t('brand')}
          value={brand_id}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.brands.map(brand => this.renderOption(brand, 'acb'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-split-seer"
          field="SEER"
          type="number"
          label={t('SEER')}
          placeholder="23.40"
          value={SEER}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'SEER')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-split-type-cooling-capacity"
          field="cooling_capacity"
          type="number"
          label={t('cooling capacity')}
          placeholder="100"
          value={fromCoolingCap(cooling_capacity, unit)}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'cooling_capacity')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-split-type-unit"
          field="unit"
          componentClass="select"
          label={t('unit')}
          value={unit}
          defaultDirty={true}
          {...customAttr}
        >
          {this.props.units.map(unit => this.renderOption(unit, 'acu'))}
        </FieldGroup>
        <FieldGroup
          id="air-conditioning-split-type-power-required"
          field="power_required"
          type="number"
          label={t('power (kW)')}
          placeholder="12"
          value={power_required}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'power_required')}
          {...customAttr}
        />
        <FieldGroup
          id="air-conditioning-split-type-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

ACSplitTypeDetail.defaultProps = {
  ac: {},
};

const mapStateToProps = state => ({
  brands: state.reference.ac.brandList,
  types: state.reference.ac.stTypes,
  units: state.reference.ac.coolingCapacityUnit,
});

const mapDispatchToProps = dispatch => ({
  listBrand: () => dispatch(listACBrand()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(ACSplitTypeDetail),
);



// WEBPACK FOOTER //
// ./src/components/ac_split_type/ACSplitTypeDetail.js